import { UserAccountIcon } from '@spiaggeit/spit-icons'
import { Button } from '@spiaggeit/spit-ui'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ExclamationMark } from '@/assets/icons/ExclamationMark'
import { useAppDispatch, useAppSelector } from '@/hooks/store'
import { isWidgetSelector } from '@/store/appSlice'
import { sectorRulesSlice } from '@/store/sectorRulesSlice'
import { hasSectorRuleTypeSelector } from '@/store/sectorRulesSlice/selectors/hasSectorRuleTypeSelector'
import { SectorRulesDialog } from '.'

export function PreemptionCode() {
  const { t } = useTranslation()

  const isWidgetMode = useAppSelector(isWidgetSelector)
  const hasPreemptionCodeValidation = useAppSelector((state) =>
    hasSectorRuleTypeSelector(state, 'preemption-code-validation')
  )
  const preemptionCode = useAppSelector(
    sectorRulesSlice.selectors.preemptionCode
  )

  const dispatch = useAppDispatch()

  const [isOpen, setIsOpen] = useState(false)

  if (!(isWidgetMode && hasPreemptionCodeValidation)) {
    return null
  }

  return (
    <div className="mb-4 text-center lg:mb-8">
      {preemptionCode ? (
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded border border-gray-500 bg-gray-50 p-2">
          <div className="flex min-w-0 items-center gap-2">
            <ExclamationMark className="size-5 shrink-0 text-secondary" />
            <div className="text-left leading-tight">
              {t('preemptionCode.alert.accessGranted', { preemptionCode })}
            </div>
          </div>

          <button
            className="ml-auto shrink-0 whitespace-nowrap underline"
            onClick={() =>
              dispatch(sectorRulesSlice.actions.removePreemptionCode())
            }
            type="button"
          >
            {t('preemptionCode.alert.removeCode')}
          </button>
        </div>
      ) : (
        <>
          <Button onClick={() => setIsOpen(true)} variant="outline">
            <UserAccountIcon className="size-5 shrink-0" />
            {t('preemptionCode.dialog.triggerBtn')}
          </Button>

          <SectorRulesDialog
            isOpen={isOpen}
            onConfirm={() => {
              setIsOpen(false)
            }}
            setIsOpen={setIsOpen}
          />
        </>
      )}
    </div>
  )
}
